import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { SingleInputDto } from '@/api.types';

/**
 * Generates a JWT token for an intern (estagiario) to access their attendance sheet.
 * @param dto - The CPF (Cadastro de Pessoas Físicas) identifier of the intern. Non-digit characters will be stripped.
 */
export async function getTokenForAttendanceSheet(dto: SingleInputDto) {
  try {
    await api.post(Endpoints.AUTH + '/folha/token', dto);
    // setTimeout(() => navigate(Links.Auth_Login), 3000);
  } catch (error) {
    return ValidateAxiosError(error, 'Falha ao obter token');
  }
}
